export default '/static/frontend/ReachDigital/12gobiking/dist/assets/applepay-d1747343.svg'